import { render } from "./German.vue?vue&type=template&id=790ef8b2&ts=true"
import script from "./German.vue?vue&type=script&lang=ts"
export * from "./German.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__